import { UserTypes } from "../constants/ActionTypes";

const LoginUser = (userData) => async (dispatch) =>
{
  try
  {
    dispatch({ payload: userData, type: UserTypes.LOGIN });
  }
  catch (err)
  {
    console.trace(err);
  }
}

const LogoutUser = () => async (dispatch) =>
{

  try
  {

  }
  catch (err)
  {
    console.trace(err);
  }
}

export { LoginUser, LogoutUser }